export class Broker {
    Name: string="";
    Phone: string="";
    License: string="";
    SalesRep: string="";
    SalesRepEmail:string="";
    Email:string="";
    TierDescription: string ="";
}
